import { Form, InputGroup } from 'react-bootstrap';
import { REFERRAL_SOURCES } from '../../../constants/constants';
import Required from '../../../utils/Required';

const ReferralSourceField = ({
  value,
  onChange,
  isSubmitting,
}) => {
  
  return (
    <Form.Group className="mb-3">
      <h4 className="required-field">How did you hear about CARES?</h4>
      <InputGroup>
        <Form.FloatingLabel label={<Required>Referral Source</Required>} controlId="referral-source">
          <Form.Select
            value={value}
            onChange={(e) => onChange(e.target.value)}
            required
            disabled={isSubmitting}
          >
            {REFERRAL_SOURCES.map((rs) => (
              <option key={rs.value} value={rs.value}>
                {rs.label}
              </option>
            ))}
          </Form.Select>
          <Form.Control.Feedback type="invalid">
            Referral Source is required.
          </Form.Control.Feedback>
        </Form.FloatingLabel>
      </InputGroup>
    </Form.Group>
  );
};

export default ReferralSourceField;